var exports = {
  "button": "MediaPlayButton.module__button___aEx3UT",
  "small": "MediaPlayButton.module__small___aEx3UT",
  "medium": "MediaPlayButton.module__medium___aEx3UT",
  "large": "MediaPlayButton.module__large___aEx3UT",
  "xlarge": "MediaPlayButton.module__xlarge___aEx3UT",
  "iconContainer": "MediaPlayButton.module__iconContainer___aEx3UT",
  "spinner": "MediaPlayButton.module__spinner___aEx3UT",
  "spin": "MediaPlayButton.module__spin___aEx3UT",
  "overlay": "MediaPlayButton.module__overlay___aEx3UT",
};

__webpack_require__.r(module.exports = exports);
